import moment from 'moment';

import { dataGetCommonStructure } from 'utils/data/data';
import { __t, applyTranslations } from 'utils/language';
import { DEFAULT_LOGICAL_OPTION } from './content';
import { HTML_DATE_FORMAT } from 'utils/date';

applyTranslations(require('components/influencer-verification-label/influencer-verification-label.i18n.json'));

const ALL_PROFILES = ['verified', 'unverified'];
const PROFILES_MSG_KEY = 'influencer_verification_label.display_profiles';

const followers = {
  min: 1,
  max: 100,
  from: 1,
  to: 100,
  transformed: {
    min: 1000,
    max: 20000075
  }
};

const genders = [
  dataGetCommonStructure('female', 'Female', 'F', false),
  dataGetCommonStructure('male', 'Male', 'M', false)
];

// $FlowIgnore - Flow wants a type for `map` but if it's added, it won't be removed from the final build
const profiles = ALL_PROFILES.map(key => (
  dataGetCommonStructure(
    key,
    __t(`${PROFILES_MSG_KEY}.${key}`),
    'false',
    false
  )
));

const timeframe = {
  startDate: moment().subtract(1, 'year').format(HTML_DATE_FORMAT),
  endDate: moment().format(HTML_DATE_FORMAT)
};

const residual = {
  countries: [],
  searchTerms: [],
  searchTermsLogicalOperator: DEFAULT_LOGICAL_OPTION
};

export const DEFAULT_FILTERS = {
  followers,
  genders,
  profiles,
  timeframe,
  ...residual
};
